module.exports = __webpack_public_path__ + "img/Grupo 1120@2x.5e6eebe1.png";